import { FacilityOptionMaintenanceService } from './../../service/facility-option-maintenance.service';
import { Option } from './interfaces/option';
import { PageInfo } from './../../../../core/models/page-info';
import { FormBuilder, FormGroup } from '@angular/forms';
import { SessionBaseComponent } from 'src/app/shared/components/session.base.component';
import { Component, Injector, Input, OnInit, ViewChild } from '@angular/core';
import { Table } from 'primeng/table';
import { FacilityOptionMaintenanceTableColumn } from './interfaces/facility-option-maintenance-table-column';
import { FacilityOptionMaintenanceTableData } from './interfaces/facility-option-maintenance-table-data';
import { SortOrder } from 'src/app/core/interface/sort-order';
import { throwError } from 'rxjs';
import { deepCopy, isNullOrEmpty } from 'src/app/core/utils/common-functions';
import { FacilityOptionMaintenanceGetRequest } from './interfaces/facility-option-maintenance-get-request';
import { FacilityOptionMaintenanceSaveRequest } from './interfaces/facility-option-maintenance-save-request';
import { PermissionConstants } from 'src/app/core/constants/permission-constants.constant';
import { UserPreferenceConstants } from 'src/app/core/constants/user-preference-constants.constant';

@Component({
  selector: 'laas-facility-option-maintenance',
  templateUrl: './facility-option-maintenance.component.html',
  styleUrls: ['./facility-option-maintenance.component.scss']
})
export class FacilityOptionMaintenanceComponent extends SessionBaseComponent implements OnInit {
  readonly viewPermissionCode = PermissionConstants.FacilityOptionMaintenance;
  currentLang: string = this.laasSetting.language;  readonly preferenceKey: string = UserPreferenceConstants.FacilityOptionMaintenance;
  // Status for the Query Form is open or not
  isSearchFormOpen = true;
  // The formGroup for the Query Form part
  searchFormGroup: FormGroup;

  // Options for Is Activated list
  isActivatedOptions: Option[] = [
    { label: 'FacilityOptionMaintenance.Option.IsActivated.Activated', value: 1 },
    { label: 'FacilityOptionMaintenance.Option.IsActivated.Deactivated', value: 0 }
  ]

  // Options for Is Default Awb Address list
  isDefaultAwbAddressOptions: Option[] = [
    { label: 'FacilityOptionMaintenance.Option.IsDefaultAwbAddress.Yes', value: 1 },
    { label: 'FacilityOptionMaintenance.Option.IsDefaultAwbAddress.No', value: 0 }
  ]

  // Status for the loading circle on the table
  isLoading: boolean = false;
  // Status for enabling a user to edit the data on the table
  isInEditMode: boolean = false;
  // The table for table part
  @ViewChild('table') table!: Table;
  // All the columns of the table have
  tableColumns: FacilityOptionMaintenanceTableColumn[] = [
    { field: 'seqNo', header: 'FacilityOptionMaintenance.Table.ColumnHeader.SeqNo', sort: true },
    { field: 'facilityCode', header: 'FacilityOptionMaintenance.Table.ColumnHeader.FacilityCode', sort: true },
    { field: 'optionType', header: 'FacilityOptionMaintenance.Table.ColumnHeader.OptionType', sort: true },
    { field: 'optionCode', header: 'FacilityOptionMaintenance.Table.ColumnHeader.OptionCode', sort: true },
    { field: 'optionDesc', header: 'FacilityOptionMaintenance.Table.ColumnHeader.OptionDesc', sort: true },
    { field: 'commonAttr01', header: 'FacilityOptionMaintenance.Table.ColumnHeader.CommonAttr01', sort: true },
    { field: 'commonAttr02', header: 'FacilityOptionMaintenance.Table.ColumnHeader.CommonAttr02', sort: true },
    { field: 'commonAttr03', header: 'FacilityOptionMaintenance.Table.ColumnHeader.CommonAttr03', sort: true },
    { field: 'commonAttr04', header: 'FacilityOptionMaintenance.Table.ColumnHeader.CommonAttr04', sort: true },
    { field: 'commonAttr05', header: 'FacilityOptionMaintenance.Table.ColumnHeader.CommonAttr05', sort: true },
    { field: 'commonAttr06', header: 'FacilityOptionMaintenance.Table.ColumnHeader.CommonAttr06', sort: true },
    { field: 'commonAttr07', header: 'FacilityOptionMaintenance.Table.ColumnHeader.CommonAttr07', sort: true },
    { field: 'commonAttr08', header: 'FacilityOptionMaintenance.Table.ColumnHeader.CommonAttr08', sort: true },
    { field: 'commonAttr09', header: 'FacilityOptionMaintenance.Table.ColumnHeader.CommonAttr09', sort: true },
    { field: 'commonAttr10', header: 'FacilityOptionMaintenance.Table.ColumnHeader.CommonAttr10', sort: true },
    { field: 'commonAttr11', header: 'FacilityOptionMaintenance.Table.ColumnHeader.CommonAttr11', sort: true },
    { field: 'commonAttr12', header: 'FacilityOptionMaintenance.Table.ColumnHeader.CommonAttr12', sort: true },
    { field: 'commonAttr13', header: 'FacilityOptionMaintenance.Table.ColumnHeader.CommonAttr13', sort: true },
    { field: 'commonAttr14', header: 'FacilityOptionMaintenance.Table.ColumnHeader.CommonAttr14', sort: true },
    { field: 'commonAttr15', header: 'FacilityOptionMaintenance.Table.ColumnHeader.CommonAttr15', sort: true },
    { field: 'commonAttr16', header: 'FacilityOptionMaintenance.Table.ColumnHeader.CommonAttr16', sort: true },
    { field: 'commonAttr17', header: 'FacilityOptionMaintenance.Table.ColumnHeader.CommonAttr17', sort: true },
    { field: 'commonAttr18', header: 'FacilityOptionMaintenance.Table.ColumnHeader.CommonAttr18', sort: true },
    { field: 'commonAttr19', header: 'FacilityOptionMaintenance.Table.ColumnHeader.CommonAttr19', sort: true },
    { field: 'commonAttr20', header: 'FacilityOptionMaintenance.Table.ColumnHeader.CommonAttr20', sort: true },
    { field: 'commonAttr21', header: 'FacilityOptionMaintenance.Table.ColumnHeader.CommonAttr21', sort: true },
    { field: 'commonAttr22', header: 'FacilityOptionMaintenance.Table.ColumnHeader.CommonAttr22', sort: true },
    { field: 'commonAttr23', header: 'FacilityOptionMaintenance.Table.ColumnHeader.CommonAttr23', sort: true },
    { field: 'notes', header: 'FacilityOptionMaintenance.Table.ColumnHeader.Notes', sort: true },
    { field: 'isActivated', header: 'FacilityOptionMaintenance.Table.ColumnHeader.IsActivated', sort: true },
    { field: 'createUser', header: 'FacilityOptionMaintenance.Table.ColumnHeader.CreateUser', sort: true },
    { field: 'createDt', header: 'FacilityOptionMaintenance.Table.ColumnHeader.CreateDt', sort: true },
    { field: 'updateUser', header: 'FacilityOptionMaintenance.Table.ColumnHeader.UpdateUser', sort: true },
    { field: 'updateDt', header: 'FacilityOptionMaintenance.Table.ColumnHeader.UpdateDt', sort: true },
    { field: 'isDefaultAwbAddress', header: 'FacilityOptionMaintenance.Table.ColumnHeader.IsDefaultAwbAddress', sort: true },
  ];
  // The columns user choose to display
  selectedTableColumns: FacilityOptionMaintenanceTableColumn[] = [];
  // Current data on the table
  tableData: FacilityOptionMaintenanceTableData[] = [];
  // Backup data when data retrieved from the back-end
  backupTableData: FacilityOptionMaintenanceTableData[] = [];
  // User current selected row on the table
  selectedRow: FacilityOptionMaintenanceTableData | null;
  // User last selected row on the table
  previousSelectedRow: FacilityOptionMaintenanceTableData | null;

  // Records for user's operation on the table
  newFacilityOptionList: FacilityOptionMaintenanceTableData[] = [];
  updatedFacilityOptionList: FacilityOptionMaintenanceTableData[] = [];
  deletedFacilityOptionSeqNoList: number[] = [];

  // For data key to distinguish the added rows on the table
  newDataKeyId: number = 0;
  // Table paging info
  pageInfo: PageInfo = {
    pageIndex: 0,
    pageSize: 5,
    totalRecords: 0,
    totalPages: 0,
  };
  // Table sorting info
  sortOrder: SortOrder = {
    property: "SeqNo",
    direction: -1
  };

  constructor(
    private injector: Injector,
    private formBuilder: FormBuilder,
    private facilityOptionMaintenanceService: FacilityOptionMaintenanceService
  ) {
    super(injector);

    this.searchFormGroup = this.formBuilder.group({
      facilityCode: null,
      optionType: null,
      optionCode: null,
      isActivated: 1
    })

    this.selectedTableColumns = this.tableColumns;
    this.selectedRow = null;
    this.previousSelectedRow = this.selectedRow;
  }

  async ngOnInit(): Promise<void> {
    await super.ngOnInit();
  }

  @Input() get selectedColumns(): FacilityOptionMaintenanceTableColumn[] {
    return this.selectedTableColumns;
  }

  set selectedColumns(cols: FacilityOptionMaintenanceTableColumn[]) {
    // Filter display columns
    this.selectedTableColumns = this.tableColumns.filter(col => cols.includes(col));
  }

  // Handle query button click on the query form
  searchBtnClick(): void {
    this.isSearchFormOpen = false;
    this.isInEditMode = false;
    this.isLoading = true;
    this.pageInfo.pageIndex = 0;
    this.table.first = 0;
    this.sendSearchRequest();
  }

  // Send Get request to service class for retrieve data
  sendSearchRequest(): void {
    this.restoreData();
    const getRequest: FacilityOptionMaintenanceGetRequest = this.createGetRequestBean();

    this.facilityOptionMaintenanceService.getFacilityOptions(getRequest).subscribe({
      next: (response) => {
        this.table.cancelRowEdit(this.selectedRow);
        if (!isNullOrEmpty(response)) {

          //Update table
          if (!isNullOrEmpty(response.content)) {
            this.tableData = deepCopy(response.content)!;
            this.backupTableData = deepCopy(this.tableData)!;
            this.selectedRow = this.tableData[0];
          }
          else {
            this.tableData = [];
            this.backupTableData = [];
            this.selectedRow = null;
          }

          this.previousSelectedRow = this.selectedRow;
          this.updateTableHighlight(this.selectedRow);

          if (this.isInEditMode) {
            this.table.initRowEdit(this.selectedRow);
          }

          // Change page Info
          this.pageInfo.totalRecords = response.totalElements;
          this.pageInfo.totalPages = this.pageInfo.totalRecords / this.pageInfo.pageSize;
        }
        else {
          throwError(response);
        }
      },
      error: (response) => {
        this.tableData = [];
        this.backupTableData = [];
        this.selectedRow = null;
        this.previousSelectedRow = this.selectedRow;
        this.pageInfo.totalRecords = 0;
        this.pageInfo.totalPages = 0;
        this.toastService.error(this.translateService.instant('FacilityOptionMaintenance.Toast.GetDataFail') + response.status);
      },
      complete: () => {
        this.isLoading = false;
      }
    })
  }

  // Handle add button click on the table
  addNewRow(): void {
    // Add a new row to table's first row
    this.tableData.splice(0, 0, {
      seqNo: null, facilityCode: null, optionType: null, optionCode: null, optionDesc: null,
      commonAttr01: null, commonAttr02: null, commonAttr03: null, commonAttr04: null, commonAttr05: null,
      commonAttr06: null, commonAttr07: null, commonAttr08: null, commonAttr09: null, commonAttr10: null,
      commonAttr11: null, commonAttr12: null, commonAttr13: null, commonAttr14: null, commonAttr15: null,
      commonAttr16: null, commonAttr17: null, commonAttr18: null, commonAttr19: null, commonAttr20: null,
      commonAttr21: null, commonAttr22: null, commonAttr23: null, notes: null, isActivated: null,
      createUser: this.userService.userInfo.userName, createDt: new Date(),
      updateUser: this.userService.userInfo.userName, updateDt: new Date(), isDefaultAwbAddress: null,
      dataKey: `--${this.newDataKeyId++}`
    })

    this.clearTableEdit()
    this.table.initRowEdit(this.selectedRow);
  }

  deleteSelectedRow(): void {
    this.confirmationService.confirm({
      header: this.translateService.instant('FacilityOptionMaintenance.Confirm.Header'),
      message: this.translateService.instant('FacilityOptionMaintenance.Confirm.Delete'),
      icon: 'pi pi-info-circle',
      accept: () => {
        this.table.cancelRowEdit(this.selectedRow);

        if (!isNullOrEmpty(this.selectedRow)) {
          const selectedRowIndex = this.tableData.indexOf(this.selectedRow!);
          if (selectedRowIndex > -1) {
            if (!isNullOrEmpty(this.tableData[selectedRowIndex].seqNo)) {
              this.addToDeletedList(this.tableData[selectedRowIndex].seqNo!)
            }
          }

          // Remove deleted row from table
          this.tableData.splice(selectedRowIndex, 1);

          // Change selected row
          if (selectedRowIndex != this.tableData.length) {
            // Change user current selected row to the next row of the deleted row
            this.selectedRow = this.tableData[selectedRowIndex];
          }
          else { // Deleted row is the last row of the current page
            // Change user current selected row to the previous row of the deleted row
            this.selectedRow = this.tableData[selectedRowIndex - 1];
          }
          this.previousSelectedRow = this.selectedRow;
          this.updateTableHighlight(this.selectedRow);

          this.table.initRowEdit(this.selectedRow);
          this.toastService.success(this.translateService.instant("FacilityOptionMaintenance.Toast.DeleteSuccess"));
        }
      }
    })
  }

  saveChanges(): void {
    this.confirmationService.confirm({
      header: this.translateService.instant('FacilityOptionMaintenance.Confirm.Header'),
      message: this.translateService.instant('FacilityOptionMaintenance.Confirm.Save'),
      icon: 'pi pi-info-circle',
      accept: () => {
        this.isLoading = true;

        // Check user's operations on the table
        this.checkNewAndUpdatedRow();

        const savedData: FacilityOptionMaintenanceSaveRequest = {
          newFacilityOptionList: this.newFacilityOptionList,
          updatedFacilityOptionList: this.updatedFacilityOptionList,
          deletedFacilityOptionSeqNoList: this.deletedFacilityOptionSeqNoList
        }

        this.facilityOptionMaintenanceService.saveFacilityOptionChanges(savedData).subscribe({
          next: () => {
            this.table.cancelRowEdit(this.selectedRow);
            this.isInEditMode = false;

            this.sendSearchRequest();
            this.toastService.success(this.translateService.instant("FacilityOptionMaintenance.Toast.SaveSuccess"));
          },
          error: response => {
            this.isLoading = false;
            this.newFacilityOptionList = [];
            this.updatedFacilityOptionList = [];
            this.toastService.error(this.translateService.instant('FacilityOptionMaintenance.Toast.SaveFail') + response.status);
          }
        });
      }
    })
  }

  restoreTableDate(): void {
    this.confirmationService.confirm({
      header: this.translateService.instant('FacilityOptionMaintenance.Confirm.Header'),
      message: this.translateService.instant('FacilityOptionMaintenance.Confirm.Restore'),
      icon: 'pi pi-info-circle',
      accept: () => {
        this.restoreData();

        // Update table to last saved data
        this.tableData = deepCopy(this.backupTableData)!;
        this.clearTableEdit();
        this.table.initRowEdit(this.selectedRow);

        this.toastService.success(this.translateService.instant('FacilityOptionMaintenance.Toast.RestoreSuccess'))
      }
    })
  }

  switchEditMode(): void {
    if (this.isInEditMode) {
      this.confirmationService.confirm({
        header: this.translateService.instant('FacilityOptionMaintenance.Confirm.Header'),
        message: this.translateService.instant('FacilityOptionMaintenance.Confirm.Exit'),
        icon: 'pi pi-info-circle',
        accept: () => {
          this.isInEditMode = false;
          this.restoreData();

          // Update table to last saved data
          this.tableData = deepCopy(this.backupTableData)!;
          this.clearTableEdit();

          this.toastService.success(this.translateService.instant('FacilityOptionMaintenance.Toast.ExitSuccess'))
        }
      })
    }
    else {
      this.isInEditMode = true;
      if (!isNullOrEmpty(this.selectedRow)) {
        this.table.initRowEdit(this.selectedRow);
      }
    }
  }

  onRowSelect(rowData: FacilityOptionMaintenanceTableData) {
    if (this.isInEditMode) {
      // Keep the selectedRow variable is pointing at the user's selected row
      // Whether is select or deselect
      this.selectedRow = rowData;

      // Reselect after user click on the same row
      if (this.previousSelectedRow != null && this.selectedRow.dataKey == this.previousSelectedRow.dataKey) {
        this.updateTableHighlight(this.previousSelectedRow);
        return;
      }

      // Change the current selected row to the user's selected row
      this.table.cancelRowEdit(this.previousSelectedRow)
      this.table.initRowEdit(this.selectedRow);
      this.previousSelectedRow = this.selectedRow;

    }
    else {
      this.previousSelectedRow = this.selectedRow;
    }
  }

  onTablePageChanging(event: { first: number, rows: number }) {
    this.pageInfo.pageSize = event.rows;
    this.pageInfo.pageIndex = event.first / event.rows;
    this.isLoading = true;
    this.sendSearchRequest();
  }

  onTableSorting(event: { field: string, order: number }) {
    if (this.tableData.length != 0) {
      this.sortOrder.property = event.field;
      this.sortOrder.direction = event.order;
      this.isLoading = true;
      this.sendSearchRequest();
    }
  }

  // Cancel current table's row editing
  private clearTableEdit() {
    this.table.cancelRowEdit(this.selectedRow);
    this.selectedRow = this.tableData[0];
    this.previousSelectedRow = this.selectedRow;

    //Avoid the highlighted part leave on the previous row
    this.updateTableHighlight(this.selectedRow);
  }

  private restoreData(): void {
    // Clear user changed action
    this.newDataKeyId = 0;
    this.newFacilityOptionList = [];
    this.updatedFacilityOptionList = [];
    this.deletedFacilityOptionSeqNoList = [];

    this.table.resetScrollTop();
  }

  private createGetRequestBean(): FacilityOptionMaintenanceGetRequest {
    return {
      facilityCode: this.searchFormGroup.value.facilityCode,
      optionType: this.searchFormGroup.value.optionType,
      optionCode: this.searchFormGroup.value.optionCode,
      isActivated: this.searchFormGroup.value.isActivated,
      pageIndex: this.pageInfo.pageIndex,
      pageSize: this.pageInfo.pageSize,
      sortOrder: this.sortOrder
    };
  }

  private checkNewAndUpdatedRow(): void {
    let saveDataIndex = 0;

    if (saveDataIndex < this.tableData.length) {
      // Check if any added row by dataKey property
      // Added row's dataKey format : --id
      for (const tableData of this.tableData) {
        if (tableData.dataKey[0] != '-') {
          break;
        }
        this.addToNewFacilityOptionList(tableData);
        saveDataIndex++;
      }

      // Reverse for maintain order of user adding new row
      this.newFacilityOptionList.reverse();

      // Compare backup table data to current table data
      for (const backupData of this.backupTableData) {
        if (this.deletedFacilityOptionSeqNoList.indexOf(backupData.seqNo!) == -1) {
          if (JSON.stringify(this.tableData[saveDataIndex]) != JSON.stringify(backupData)) {
            this.addToUpdateList(this.tableData[saveDataIndex]);
          }
          saveDataIndex++;
        }
      }
    }
  }

  // Control the selection highlighting back to the row
  private updateTableHighlight(currentRow: FacilityOptionMaintenanceTableData | null): void {
    if (!currentRow) {
      return;
    }
    this.table.selection = currentRow;
    this.table.selectionKeys = {};
    this.table.selectionKeys[currentRow.dataKey] = 1;
    this.table.tableService.onSelectionChange();
  }

  private addToNewFacilityOptionList(rowData: FacilityOptionMaintenanceTableData): void {
    this.newFacilityOptionList.push(rowData);
  }

  private addToUpdateList(rowData: FacilityOptionMaintenanceTableData): void {
    rowData.updateUser = this.userService.userInfo.userName;
    rowData.updateDt = new Date();
    this.updatedFacilityOptionList.push(rowData);
  }

  private addToDeletedList(seqNo: number): void {
    this.deletedFacilityOptionSeqNoList.push(seqNo);
  }
}
